import api from "../../api/api";
import API_URL from "../../api/url";
import axios from 'axios';

const CommentRatingRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  commentRatingList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getRating}`, {
    
    params: {
      page: values?.page,
      search: values?.search
    }

  }),
  deleteRating: (id) => api.post(`${API_URL.BASEURL}${API_URL.postDeleteRating}`, id),

  statusUpdate: (values) => api.post(`${API_URL.BASEURL}${API_URL.postRatingStatusUpdate}`, values),



  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=category`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default CommentRatingRequest